import React, { useState } from 'react';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

import { Link } from 'react-router-dom';
import Slider, { Range } from 'rc-slider';
import { TextField } from '@material-ui/core';
import 'rc-slider/assets/index.css';
import './Tracker.css';
import { Container } from '@material-ui/core';

import speechTherapyImage from '../../assets/tracker-assets/speech_therapy.png';
import psycologistImage from '../../assets/tracker-assets/psycologist.png';
import pediatricsImage from '../../assets/tracker-assets/pediatrics.png';
import dermatologyImage from '../../assets/tracker-assets/dermatology.png';
import optometristImage from '../../assets/tracker-assets/optometrist.png';
import nutritionCounsellingImage from '../../assets/tracker-assets/nutrition_counselling.png';

import familySuggestionsImage from '../../assets/tracker-assets/family_primary.png';

import blogTemplateImage from '../../assets/tracker-assets/blog_template.png';

import reportsImage from '../../assets/tracker-assets/reports.png';

const consultationAssets = [
	{ name: 'Speech Therapy', image: speechTherapyImage },
	{ name: 'Psycologist', image: psycologistImage },
	{ name: 'Pediatrics', image: pediatricsImage },
	{ name: 'Dermatology', image: dermatologyImage },
	{ name: 'Optometrist', image: optometristImage },
	{ name: 'Nutrition Counselling', image: nutritionCounsellingImage },
];

const faqList = new Array(3).fill(
	'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Doloremque quas nam laboriosam reiciendis quo amet omnis fugit voluptate aut voluptatem.'
);

const blogList = new Array(3).fill({
	image: blogTemplateImage,
	content:
		'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eaque dicta ducimus doloribus id exercitationem voluptate!',
});

const standardsList = [
	{
		title: 'new born',
		content:
			'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Odit consectetur ad deserunt asperiores delectus aperiam recusandae animi minus. Doloribus deleniti laboriosam voluptas tenetur, atque voluptatem officiis incidunt neque veniam nisi aut numquam. Soluta, earum! Laboriosam explicabo assumenda fuga commodi, corporis harum reprehenderit ducimus, ut suscipit aliquid maiores, sapiente quibusdam! Consectetur.',
	},
	{
		title: 'infant',
		content:
			'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Odit consectetur ad deserunt asperiores delectus aperiam recusandae animi minus. Doloribus deleniti laboriosam voluptas tenetur, atque voluptatem officiis incidunt neque veniam nisi aut numquam. Soluta, earum! Laboriosam explicabo assumenda fuga commodi, corporis harum reprehenderit ducimus, ut suscipit aliquid maiores, sapiente quibusdam! Consectetur.',
	},
	{
		title: 'toddler',
		content:
			'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Odit consectetur ad deserunt asperiores delectus aperiam recusandae animi minus. Doloribus deleniti laboriosam voluptas tenetur, atque voluptatem officiis incidunt neque veniam nisi aut numquam. Soluta, earum! Laboriosam explicabo assumenda fuga commodi, corporis harum reprehenderit ducimus, ut suscipit aliquid maiores, sapiente quibusdam! Consectetur.',
	},
	{
		title: 'preschool',
		content:
			'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Odit consectetur ad deserunt asperiores delectus aperiam recusandae animi minus. Doloribus deleniti laboriosam voluptas tenetur, atque voluptatem officiis incidunt neque veniam nisi aut numquam. Soluta, earum! Laboriosam explicabo assumenda fuga commodi, corporis harum reprehenderit ducimus, ut suscipit aliquid maiores, sapiente quibusdam! Consectetur.',
	},
	{
		title: 'school age',
		content:
			'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Odit consectetur ad deserunt asperiores delectus aperiam recusandae animi minus. Doloribus deleniti laboriosam voluptas tenetur, atque voluptatem officiis incidunt neque veniam nisi aut numquam. Soluta, earum! Laboriosam explicabo assumenda fuga commodi, corporis harum reprehenderit ducimus, ut suscipit aliquid maiores, sapiente quibusdam! Consectetur.',
	},
];

const TrackerNavList = [
	'Overview',
	'Tracker',
	'Standards',
	'Reports',
	'FAQs',
	'Blogs',
	'Suggestions',
	'Consultation',
	'Ask Query',
];

const testimonialList = new Array(3).fill({
	name: 'A Agarwal',
	content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo, cum!',
	image: blogTemplateImage,
});

const Tracker = (props) => {
	const { bearerToken } = props;
	const [childName, setChildName] = useState('');
	const [mobileNumber, setMobileNumber] = useState('');
	const [sliderWeight, setSliderWeight] = useState(35);
	const [sliderHeight, setSliderHeight] = useState(80);
	const [sliderAge, setSliderAge] = useState(12);
	return (
		<div className='Tracker'>
			<Navbar bearerToken={bearerToken} />
			<div className='tracker-nav hide-on-med-and-down'>
				{TrackerNavList.map((aNav) => (
					<p>{aNav}</p>
				))}
			</div>
			<div className='overview container'>
				<h2>Overview</h2>
				<p>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis autem ducimus
					fuga voluptates et ratione sapiente quia, enim amet adipisci odio veniam
					repellendus. Porro repellendus ullam accusamus temporibus, ea corporis eos
					aspernatur officia quam quis! Quisquam omnis doloremque pariatur voluptates?
					Placeat vel deleniti illo in voluptas delectus nisi commodi temporibus?
				</p>
				<p>
					Lorem ipsum dolor sit, amet consectetur adipisicing elit. Reiciendis ratione
					commodi magnam a ea quas impedit, odio vel. Laboriosam ea necessitatibus quis
					ipsam earum placeat. Aliquam veritatis in recusandae earum eum consequatur
					consequuntur facilis nulla facere, vero repellendus! Non dicta voluptatibus
					deserunt quam consectetur exercitationem eligendi suscipit eaque earum itaque.
				</p>
				<hr />
			</div>
			<div className='general-info'>
				<div className='growth-tracker'>
					<div className='value'>
						<div className='container'>
							<p>Weight</p>
							<p>
								<span>1Kg</span>
								<span>100Kg</span>
							</p>
							<Slider
								min={1}
								max={100}
								defaultValue={sliderWeight}
								onAfterChange={(newWeight) => {
									setSliderWeight(newWeight);
								}}
							/>
						</div>
						<div className='value-reflect'>
							<TextField
								value={sliderWeight}
								variant='outlined'
								label='WEIGHT'
								inputProps={{ readOnly: true }}
							/>
						</div>
					</div>
					<div className='value'>
						<div className='container'>
							<p>Height</p>
							<p>
								<span>30cm</span>
								<span>200cm</span>
							</p>
							<Slider
								min={30}
								max={300}
								defaultValue={sliderHeight}
								onAfterChange={(newHeight) => {
									setSliderHeight(newHeight);
								}}
							/>
						</div>
						<div className='value-reflect'>
							<TextField
								value={sliderHeight}
								variant='outlined'
								label='HEIGHT'
								inputProps={{ readOnly: true }}
							/>
						</div>
					</div>
					<div className='value'>
						<div className='container'>
							<p>Age</p>
							<p>
								<span>1Yr</span>
								<span>30Yr</span>
							</p>
							<Slider
								min={1}
								max={30}
								defaultValue={sliderAge}
								onAfterChange={(newAge) => {
									setSliderAge(newAge);
								}}
							/>
						</div>
						<div className='value-reflect'>
							<TextField
								value={sliderAge}
								variant='outlined'
								label='AGE'
								inputProps={{ readOnly: true }}
							/>
						</div>
					</div>
					<button className='btn'>track now</button>
				</div>
				<div className='testimonials hide-on-med-and-down'>
					<div className='test-list'>
						<p>Testimonials</p>
						{testimonialList.map((aTestimonial) => (
							<TestimonialCard {...aTestimonial} />
						))}
					</div>
				</div>
			</div>
			<div className='standards container'>
				<hr />
				<h2>Standards</h2>
				<p className='helper'>Five Stages of child growth</p>
				{standardsList.map((aStandard) => (
					<div>
						<h5>{aStandard.title}</h5>
						<p>{aStandard.content}</p>
					</div>
				))}
			</div>
			<div className='reports container row'>
				<hr />
				<h2>Reports</h2>
				<div className='r-templates col s12 l7'>
					<div>
						<img src={reportsImage} />
						<h5>
							For comprehensive <strong>Child Growth Reports</strong>
						</h5>
						<hr className='container' />
					</div>
				</div>
				<div className='col s1' />
				<div className='download-report col s12 l4'>
					<h6>Download Report</h6>
					<p>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum, maiores?
					</p>
					<input
						placeholder='Select Child Name'
						value={childName}
						onChange={(event) => {
							setChildName(event.target.value);
						}}
					/>
					<input
						placeholder='Your Mobile Number'
						value={mobileNumber}
						onChange={(event) => {
							setMobileNumber(event.target.value);
						}}
					/>
					<p>An OTP will be sent on this number</p>
					<button className='btn'>Check Status</button>
				</div>
			</div>
			<div className='faqs container'>
				<h2>FAQs:</h2>
				{faqList.map((aFaq) => (
					<p>{aFaq}</p>
				))}
			</div>
			<div className='blogs container'>
				<hr />
				<p className='title'>Blogs</p>
				<div className='bloglist'>
					{blogList.map((aBlog) => (
						<BlogCard {...aBlog} />
					))}
				</div>
				<Link>View All {`>`}</Link>
			</div>
			<div className='suggestions container row'>
				<hr />
				<h2>Suggestions</h2>
				<div className='col s12 l7'>
					<p>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, velit sit.
						Nulla voluptatibus labore, unde, soluta fugiat ab odio ullam quibusdam
						molestias optio eius similique fuga nostrum quasi veniam cum, eos
						dignissimos doloremque repudiandae enim commodi explicabo consequatur? Sint,
						omnis?
					</p>
					<p>
						Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam officia
						beatae tempore mollitia voluptates ad optio deleniti totam, nulla nihil!
					</p>
				</div>
				<div className='col s12 l5'>
					<img src={familySuggestionsImage} />
				</div>
			</div>
			<div className='consultation container'>
				<hr />
				<h2>Consultation</h2>
				<div className='container row'>
					{consultationAssets.map((anAsset) => (
						<div className='col s12 m6 l4'>
							<img src={anAsset.image} />
							<p>{anAsset.name}</p>
						</div>
					))}
				</div>
			</div>
			<div className='ask-query container'>
				<h2>Ask Query: </h2>
				<textarea className='browser-default' placeholder='Your Message' />
				<div>
					<p>your contact information</p>
					<input type='text' placeholder='First Name' className='browser-default' />
					<input type='text' placeholder='Last Name' className='browser-default' />
					<p>How would you like us to get in touch with you ?</p>
					<input type='text' placeholder='Email' className='browser-default' />
					<input type='text' placeholder='Email Address' className='browser-default' />

					<input type='text' placeholder='India(+91)' className='browser-default' />
					<input type='text' placeholder='Phone' className='browser-default' />
					<p>Country</p>
					<input type='text' placeholder='Country' className='browser-default' />
				</div>
			</div>
			<Footer />
		</div>
	);
};

const BlogCard = (props) => {
	const { image, content } = props;
	return (
		<div className='single-blog'>
			<img src={image} />
			<p>{content}</p>
			<Link>
				<button>Read More</button>
			</Link>
		</div>
	);
};

const TestimonialCard = (props) => {
	const { name, content, image } = props;
	return (
		<div className='single-testimonial'>
			<div>
				<img src={image} />
				<p>{content}</p>
			</div>
			<p>{name}</p>
			<hr />
		</div>
	);
};

export default Tracker;
